"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniqueField = exports.mapToSingleField = exports.getUnique = exports.sumByField = exports.groupByField = void 0;
var groupByField = function (array, fieldName) {
    return array.reduce(function (result, item) {
        var _a, _b;
        var groupName = item[fieldName];
        var existingGroup = result[groupName];
        if (!groupName || typeof groupName !== 'string') {
            throw new Error('The field name has to be string either string or number');
        }
        if (existingGroup) {
            return __assign(__assign({}, result), (_a = {}, _a[groupName] = __spreadArray(__spreadArray([], __read(existingGroup), false), [item], false), _a));
        }
        return __assign(__assign({}, result), (_b = {}, _b[groupName] = [item], _b));
    }, {});
};
exports.groupByField = groupByField;
var sumByField = function (array, fieldName) {
    return array.reduce(function (sum, item) {
        if (typeof item[fieldName] !== 'number') {
            return sum;
        }
        return sum + item[fieldName];
    }, 0);
};
exports.sumByField = sumByField;
var getUnique = function (array) { return Array.from(new Set(array)); };
exports.getUnique = getUnique;
var mapToSingleField = function (array, fieldName) { return array.map(function (item) { return item[fieldName]; }); };
exports.mapToSingleField = mapToSingleField;
var getUniqueField = function (array, fieldName) { return (0, exports.getUnique)((0, exports.mapToSingleField)(array, fieldName)); };
exports.getUniqueField = getUniqueField;
